export const PROVIDER_RATE_SHEET_RULE_MAX_LENGTH = 1000;
export const PROVIDER_RATE_SHEET_RULE_MAX_ACTIVE = 10;
